export const INVOICE_SERVICE_CREATION_DATE = '2021-08-01';
